const stats = [
  { value: "3+", label: "Years Since Green Monday" },
  { value: "1", label: "Voice on the Radio. Still Alive." },
  { value: "∞", label: "Reasons She Won\'t Stop" },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-[#0D0D0D] py-24 px-6">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        {/* Left Content */}
        <div>
          <span className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-[0.3em] uppercase block mb-5">
            [ Backstory ]
          </span>
          <h2 className="font-['Special_Elite'] text-white text-4xl md:text-5xl lg:text-6xl leading-tight mb-10">
            The Girl Who<br />Chose To<br />
            <span className="text-[#C8922A]">Fight.</span>
          </h2>

          {/* Stats Row */}
          <div className="flex flex-col sm:flex-row gap-0 mb-10 border border-[#2C2C2C]">
            {stats.map((stat, i) => (
              <div
                key={i}
                className={`flex-1 px-6 py-5 ${
                  i < stats.length - 1 ? "border-b sm:border-b-0 sm:border-r border-[#8B1A1A]/40" : ""
                }`}
              >
                <div className="font-['Special_Elite'] text-[#C8922A] text-3xl font-bold mb-1">
                  {stat.value}
                </div>
                <div className="font-['Rajdhani'] text-[#777] text-xs tracking-wide leading-snug">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>

          {/* Bio */}
          <div className="space-y-4 font-['Rajdhani'] text-[#AAAAAA] text-base leading-relaxed">
            <p>
              Before the world ended, Jordan Reyes was a <strong className="text-white">star softball pitcher</strong> on a college scholarship — a competitor by nature, not a fighter. Her strength was born from discipline, practice, and a deep-seated need to protect those she loved.
            </p>
            <p>
              She met <strong className="text-[#C8922A]">Aidan</strong> during her sophomore year, a culinary student whose effortless joy balanced her fierce intensity. Together they were unstoppable. Then Green Monday came, and the world they knew ceased to exist.
            </p>
            <p>
              After the supermarket massacre separated them, Jordan became something else entirely. The survivors who saw her move through the wasteland — silent, ruthless, efficient — started calling her something that stuck: <strong className="text-white">The Wraith</strong>.
            </p>
          </div>

          <div className="mt-8 flex items-center gap-4">
            <div className="h-px flex-1 bg-[#8B1A1A]/40" />
            <span className="font-['Share_Tech_Mono'] text-[#555] text-xs tracking-widest">
              HER STORY CONTINUES
            </span>
            <div className="h-px flex-1 bg-[#8B1A1A]/40" />
          </div>
        </div>

        {/* Right Image */}
        <div className="relative">
          <div className="relative overflow-hidden">
            <img
              src="https://storage.readdy-site.link/project_files/4353f4cf-bd60-4a53-b8de-9b86b4213d15/d05ab320-d21a-4032-97a2-7c2e2795691c_openart-021774822815440682bfa727eaa8ae907bb4f408e14b63dc3cf2b_0_1774822823429_2d3b9d1d.png?v=79f46b6318ed102d69ac42ebaa847259"
              alt="Jordan Reyes – The Wraith, post-apocalyptic survivor"
              className="w-full h-[500px] md:h-[650px] object-cover object-top"
            />
            {/* Overlay effects */}
            <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-transparent to-transparent" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0D0D0D]/30 via-transparent to-transparent" />
          </div>

          {/* Floating tag */}
          <div className="absolute top-6 right-6 bg-[#0A0A0A]/90 border border-[#8B1A1A]/60 px-4 py-3">
            <div className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs tracking-widest uppercase mb-1">
              Designation
            </div>
            <div className="font-['Special_Elite'] text-white text-lg tracking-wide">
              &ldquo;The Wraith&rdquo;
            </div>
          </div>

          {/* Bottom info */}
          <div className="absolute bottom-6 left-6 right-6 flex justify-between items-end">
            <div>
              <div className="font-['Special_Elite'] text-white text-xl">Jordan Reyes</div>
              <div className="font-['Share_Tech_Mono'] text-[#777] text-xs tracking-widest uppercase">
                Scavenger · Survivor · Protector
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-2 h-2 rounded-full bg-[#C8922A] animate-pulse" />
              <span className="font-['Share_Tech_Mono'] text-[#C8922A] text-xs">Active</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
